import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import LoadingOverlay from './components/LoadingOverlay';
import API from './services/API';

import App from './App';
import Login from './scenes/Login';

class Root extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: true,
            isLogged: false
        }
    }

    async componentDidMount() {
        const isLogged = await API.Login.isLogged();

        this.setState({
            isLoading: false,
            isLogged
        })
    }

    getRouting() {
        const { isLogged } = this.state;

        return (
            <Switch>
                <Route path="/login" render={() => isLogged ? <Redirect to="/" /> : <Login />}/>
                <Route path="/" render={() => isLogged ? <App /> : <Redirect to={document.location.href.includes('login') ? `/login` : `/login?back_to=${window.btoa(document.location.pathname)}`} />}/>
            </Switch>
        )
    }

    render() {
        const { isLoading } = this.state;

        return isLoading ? (<LoadingOverlay/>) : this.getRouting();
    }
}

export default Root;


// WEBPACK FOOTER //
// ./src/Root.js